import { render, staticRenderFns } from "./goodsRow.vue?vue&type=template&id=1bb00ef8&scoped=true&"
import script from "./goodsRow.vue?vue&type=script&lang=js&"
export * from "./goodsRow.vue?vue&type=script&lang=js&"
import style0 from "./goodsRow.vue?vue&type=style&index=0&id=1bb00ef8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb00ef8",
  null
  
)

export default component.exports